import CallActionAvatarComponent from './CallActionAvatar.component';

export * from './CallActionAvatar.component';
export default CallActionAvatarComponent;
